import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, HeadphonesIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ValueTable() {
  const bonos = [{
    img: 'https://cdn.magicpatterns.com/uploads/76NasFNRMyvLgXN6RxAPwD/BONO_1.png',
    title: 'Domina la IA desde Cero',
    subtitle: 'Empieza en minutos, sin experiencia',
    bullets: ['Configuración paso a paso', 'Prompts listos para usar', 'Evita errores comunes'],
    result: 'Resultados claros desde el día 1',
    footer: 'Ideal si estás comenzando',
    value: '$27',
    badge: 'RECOMENDADO PARA EMPEZAR',
    badgeStyle: 'bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20',
    highlight: false
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/oM8nNyUCCnEVKDKckHSw28/BONO_2.png',
    title: 'Las 20 Apps que Potencian la IA',
    subtitle: 'Convierte la IA en un ecosistema real',
    bullets: ['Automatiza tareas sin programar', 'Crea contenido en minutos', 'Organiza tu trabajo'],
    result: 'Dejas de trabajar manualmente',
    footer: 'Ideal para escalar resultados',
    value: '$37',
    badge: 'SISTEMA COMPLETO',
    badgeStyle: 'bg-white/5 text-[#E8E0D0] border border-white/10',
    highlight: false
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/nNr2wroDUUD7QhtQrYf9tm/BONO_3.png',
    title: 'Automatización Total',
    subtitle: 'Sistemas que trabajan por ti',
    bullets: ['Agenda semanal automática', 'Correos resumidos cada día', 'Contenido generado solo', 'Flujos automáticos'],
    result: 'Recuperas horas cada día',
    footer: 'Ideal si quieres ahorrar tiempo real',
    value: '$47',
    badge: '🔥 MÁS VENDIDO',
    badgeStyle: 'bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30',
    highlight: true
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/ba8YnrZLkVp9ko8DGHiG7i/ChatGPT_Image_31_mar_2026,_05_14_14_p.m..png',
    title: 'Los 15 Casos de Uso de IA que Nadie te Enseña',
    subtitle: '15 usos sorprendentes de la IA con el prompt exacto de cada uno.',
    bullets: ['Simular negociaciones difíciles antes de tenerlas', 'Depurar decisiones sin sesgo emocional', 'Analizar tu personalidad con tus propias palabras', 'Y más — Listo para usar hoy'],
    result: 'Dominas la IA en situaciones que nadie más aprovecha',
    footer: 'Ideal si quieres ir más allá de lo básico',
    value: '$27',
    badge: 'BONO EXCLUSIVO',
    badgeStyle: 'bg-white/5 text-[#E8E0D0] border border-white/10',
    highlight: false
  }];
  return <motion.div id="value-table" variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="scroll-mt-8" data-id="element-136">
      <h2 className="text-3xl max-sm:text-2xl md:text-4xl font-serif font-bold text-[#E8E0D0] mb-8 max-sm:mb-5 text-center" data-id="element-137">
        Recuerda todo lo que obtienes hoy:
      </h2>
      {/* Guía Principal + Audiolibro - Unified Hero Card */}
      <div className="bg-[#111111] border border-[#D4AF37]/30 rounded-2xl max-sm:rounded-xl overflow-hidden shadow-[0_0_30px_rgba(212,175,55,0.1)] mb-8 max-sm:mb-5" data-id="element-138">
        {/* Top accent line */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" data-id="element-139" />
        <div className="p-6 max-sm:p-4 md:p-8" data-id="element-140">
          <div className="flex items-center justify-center gap-2 mb-6 max-sm:mb-4" data-id="element-141">
            <span className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#D4AF37] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full border border-[#D4AF37]/20" data-id="element-142">
              Producto Principal — 2 en 1
            </span>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-6 max-sm:gap-4" data-id="element-143">
            {/* Book cover */}
            <div className="w-40 max-sm:w-32 md:w-44 shrink-0" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/5wgkHHHdwGYyVc5LwE28SX/Guia_principal.png" alt="Guía Principal + Audiolibro: IA al Rescate" loading="lazy" className="w-full h-auto rounded-lg shadow-[0_0_25px_rgba(212,175,55,0.2)]" data-id="element-145" />
            </div>

            <div className="text-center md:text-left flex-1" data-id="element-146">
              <h3 className="text-xl max-sm:text-lg md:text-2xl font-serif font-bold text-[#E8E0D0] mb-3" data-id="element-147">
                📘 Guía + 🎧 Audiolibro: IA al Rescate
              </h3>

              {/* Two formats side by side */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4" data-id="element-148">
                {/* Ebook */}
                <div className="bg-[#0A0A0A] border border-[#D4AF37]/20 rounded-xl p-3" data-id="element-149">
                  <p className="text-xs uppercase tracking-widest text-[#D4AF37] font-bold mb-1" data-id="element-150">
                    📘 Ebook
                  </p>
                  <p className="text-sm text-[#A09880] leading-relaxed" data-id="element-151">
                    60 páginas prácticas con prompts listos para copiar y pegar
                  </p>
                </div>
                {/* Audiolibro */}
                <div className="bg-[#0A0A0A] border border-[#D4AF37]/20 rounded-xl p-3" data-id="element-152">
                  <p className="text-xs uppercase tracking-widest text-[#D4AF37] font-bold mb-1 flex items-center gap-1" data-id="element-153">
                    <HeadphonesIcon className="w-3 h-3" data-id="element-154" /> Audiolibro
                  </p>
                  <p className="text-sm text-[#A09880] leading-relaxed" data-id="element-155">
                    Audio guiado basado en los 6 capítulos del ebook
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-4 text-left" data-id="element-156">
                {['Lee o escucha — tú decides', 'Basado en los 6 capítulos del ebook', 'Ideal para aprender sin estar frente a la pantalla', 'Perfecto para aprender y ejecutar más rápido'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-157">
                    <CheckCircle2Icon className="w-4 h-4 text-[#D4AF37] shrink-0 mt-0.5" data-id="element-158" />
                    <span className="text-sm text-[#E8E0D0]" data-id="element-159">{item}</span>
                  </div>)}
              </div>

              <div className="flex items-center justify-center md:justify-start gap-3 flex-wrap" data-id="element-160">
                <span className="text-[#A09880] line-through text-sm" data-id="element-161">
                  Valor: $116
                </span>
                <span className="bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-162">
                  Todo incluido hoy
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bonos Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-sm:gap-3 mb-8 max-sm:mb-5" data-id="element-163">
        {bonos.map((bono, i) => <div key={i} className={['relative bg-[#111111] border rounded-2xl max-sm:rounded-xl overflow-hidden p-5 max-sm:p-4 text-left transition-all', bono.highlight ? 'border-[#D4AF37]/40 shadow-[0_0_30px_rgba(212,175,55,0.15)]' : 'border-[#D4AF37]/10'].join(' ')} data-id="element-164">
            {bono.highlight && <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" data-id="element-165" />}
            <div className="flex items-start gap-4 mb-4" data-id="element-166">
              <div className="w-24 max-sm:w-20 md:w-24 shrink-0" data-id="element-167">
                <img src={bono.img} alt={bono.title} loading="lazy" className="w-full h-auto rounded-lg shadow-lg" data-id="element-168" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-169">
                <span className={`inline-block text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-2 ${bono.badgeStyle}`} data-id="element-170">
                  {bono.badge}
                </span>
                <h4 className="text-lg max-sm:text-base font-serif font-bold text-[#E8E0D0] leading-tight mb-1" data-id="element-171">
                  {bono.title}
                </h4>
                <p className="text-[#A09880] text-sm leading-relaxed" data-id="element-172">
                  {bono.subtitle}
                </p>
              </div>
            </div>
            <div className="space-y-2 mb-4" data-id="element-173">
              {bono.bullets.map((item, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-174">
                  <CheckCircle2Icon className="w-4 h-4 text-[#D4AF37] shrink-0 mt-0.5" data-id="element-175" />
                  <span className="text-sm text-[#E8E0D0] leading-relaxed" data-id="element-176">
                    {item}
                  </span>
                </div>)}
            </div>
            <div className="bg-[#0A0A0A] border border-[#D4AF37]/10 rounded-xl px-4 py-3 mb-3" data-id="element-177">
              <p className="text-xs uppercase tracking-widest text-[#A09880] mb-1" data-id="element-178">
                Resultado
              </p>
              <p className="text-sm font-semibold text-[#D4AF37]" data-id="element-179">
                {bono.result}
              </p>
            </div>
            <p className="text-xs text-[#A09880] font-medium mb-3" data-id="element-180">
              {bono.footer}
            </p>
            <div className="flex items-center justify-between gap-3" data-id="element-181">
              <span className="text-[#A09880] line-through text-sm" data-id="element-182">
                Valor: {bono.value}
              </span>
              <span className={['text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full', bono.highlight ? 'bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20' : 'bg-white/5 text-[#E8E0D0] border border-white/10'].join(' ')} data-id="element-183">
                Incluido hoy
              </span>
            </div>
          </div>)}
      </div>
    </motion.div>;
}